/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Mad_Sawfish_DialInputs */

const fr_antsy_mad_sawfish_dial = /** @type {(inputs: Antsy_Mad_Sawfish_DialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer`)
};

/**

* @param {Antsy_Mad_Sawfish_DialInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const antsy_mad_sawfish_dial = /** @type {((inputs?: Antsy_Mad_Sawfish_DialInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Mad_Sawfish_DialInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_antsy_mad_sawfish_dial(inputs)
});